import "core-js/modules/es.string.trim";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
import { captcha, getAppConfig } from '@/api/user';
import { Common } from '@/utils/common';
export default {
  name: 'Login',
  data: function data() {
    var checkUsername = function checkUsername(rule, value, callback) {
      if (value.length < 5) {
        return callback(new Error('请输入正确的用户名'));
      } else {
        callback();
      }
    };

    var checkPassword = function checkPassword(rule, value, callback) {
      if (value.length < 6) {
        return callback(new Error('请输入正确的密码'));
      } else {
        callback();
      }
    };

    return {
      curYear: 0,
      lock: 'lock',
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        captchaId: ''
      },
      rules: {
        username: [{
          validator: checkUsername,
          trigger: 'blur'
        }],
        password: [{
          validator: checkPassword,
          trigger: 'blur'
        }]
      },
      logVerify: '',
      picPath: '',
      activeName: 'account',
      errMsg: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.curYear = new Date().getFullYear();
              _this.errMsg = Common.getQueryString('err').trim();

              _this.loginVerify();

              _context.next = 5;
              return getAppConfig({
                'appSource': process.env.VUE_APP_NAME
              });

            case 5:
              res = _context.sent;

              if (res.code == 0) {
                setTimeout(function () {
                  var obj = new WxLogin({
                    self_redirect: false,
                    id: 'wxCode',
                    appid: res.data,
                    scope: 'snsapi_login',
                    redirect_uri: encodeURIComponent(window.origin + '/' + process.env.VUE_APP_BASE_API + '/base/wxauth/login?appSource=' + process.env.VUE_APP_NAME),
                    state: '',
                    style: 'black'
                  });
                }, 500);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: _objectSpread(_objectSpread({}, mapActions('user', ['LoginIn'])), {}, {
    login: function login() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.LoginIn(_this2.loginForm);

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    submitForm: function submitForm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$refs.loginForm.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(v) {
                    var flag;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!v) {
                              _context3.next = 7;
                              break;
                            }

                            _context3.next = 3;
                            return _this3.login();

                          case 3:
                            flag = _context3.sent;

                            if (!flag) {
                              _this3.loginVerify();
                            }

                            _context3.next = 10;
                            break;

                          case 7:
                            _this3.$message({
                              type: 'error',
                              message: '请正确填写登录信息',
                              showClose: true
                            });

                            _this3.loginVerify();

                            return _context3.abrupt("return", false);

                          case 10:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    changeLock: function changeLock() {
      this.lock = this.lock === 'lock' ? 'unlock' : 'lock';
    },
    loginVerify: function loginVerify() {
      var _this4 = this;

      captcha({}).then(function (ele) {
        _this4.picPath = ele.data.picPath;
        _this4.loginForm.captchaId = ele.data.captchaId;
      });
    }
  })
};